module.exports = __webpack_public_path__ + "img/27_24.13c92b6b.png";